module.exports = __webpack_public_path__ + "img/关于我们.1d6228aa.svg";